import {LanguageCountryConfig} from './language-country.config';

export const UNITED_KINGDOM_LANGUAGE_CONFIG: LanguageCountryConfig = {
  code: 'en',
  locale: 'en-GB',
  countryCode: 'GB',
  shortLabel: 'EN',
  labelKey: 'language.english',
  flag: '\uD83C\uDDEC\uD83C\uDDE7'
};
